import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = {
  type: "button",
  class: "btn btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_4 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  type: "button",
  class: "btn btn-light-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_customers_export_modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "svg-icon svg-icon-3" }
const _hoisted_13 = ["data-bs-target", "onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_HorseFilter = _resolveComponent("HorseFilter")!
  const _component_vue3_json_excel = _resolveComponent("vue3-json-excel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TreatmentModal = _resolveComponent("TreatmentModal")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'groomer'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen031.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.translate('filter')), 1)
          ]),
          (_ctx.excelData)
            ? (_openBlock(), _createBlock(_component_HorseFilter, {
                key: 0,
                onFilterSelected: _ctx.searchHorse,
                onReset: _ctx.onReset
              }, null, 8, ["onFilterSelected", "onReset"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_vue3_json_excel, {
              "json-data": _ctx.excelData,
              fields: _ctx.excelHeader,
              worksheet: "horses WorkSheet",
              name: "horses.xls"
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr078.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate('Export Horses')), 1)
                ])
              ]),
              _: 1
            }, 8, ["json-data", "fields"]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.can('create', 'groomer'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('horses-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('Add New Horses')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-nameEn": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses.nameEn), 1)
            ]),
            "cell-category": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses.category.nameEn), 1)
            ]),
            "cell-passport": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses.passport), 1)
            ]),
            "cell-status": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses.status.nameEn), 1)
            ]),
            "cell-type": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses?.type?.nameEn), 1)
            ]),
            "cell-gender": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses.gender?.nameEn), 1)
            ]),
            "cell-horseLocationName": _withCtx(({ row: horses }) => [
              _createTextVNode(_toDisplayString(horses?.horseLocationName), 1)
            ]),
            "cell-horseTag": _withCtx(({ row: horse }) => [
              _createElementVNode("img", {
                onClick: ($event: any) => (_ctx.printHorseTag(horse)),
                src: "/media/icons/duotune/files/fil017.svg",
                style: {"cursor":"pointer"},
                title: "Click to print horse tag"
              }, null, 8, _hoisted_11)
            ]),
            "cell-actions": _withCtx(({ row: horse }) => [
              _createVNode(_component_router_link, {
                to: `/manage/operations/horses/treatment-overview/${horse.id}`,
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("button", {
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": `#kt_modal_${horse.id}`,
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: ($event: any) => {
              _ctx.horseId = horse.id;
              _ctx.editMedical(horse.id);
            }
              }, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/medicine/med002.svg" })
                ])
              ], 8, _hoisted_13),
              _createVNode(_component_router_link, {
                to: `/manage/operations/horses/horse-editing/${horse.id}`,
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_TreatmentModal, {
                index: horse.id,
                onCreate: _ctx.addNewTreatment,
                horseId: _ctx.horseId
              }, null, 8, ["index", "onCreate", "horseId"])
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}